import { QuestionBase } from './question-base';

export class functionLink extends QuestionBase<string> {
  override controlType = 'functionLink';
}